import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

headerStyles.container = {
    ...headerStyles.container,
    css: css`
        ${headerStyles.container?.css}
        padding-bottom: 40px;

        ${mediaQueriesBP.maxMD} {
            padding-bottom: 24px;
        }
    `,
};

headerStyles.heading = {
    ...headerStyles.heading,
    variant: "h1",
};

headerStyles.toggleFilterButton = {
    ...headerStyles.toggleFilterButton,
    css: css`
        ${headerStyles.toggleFilterButton?.css}
        background-color: transparent;
        border: 0;
        width: auto;
        padding: 0 !important;

        &:hover,
        &:focus,
        &:active {
            background-color: transparent !important;
            border: 0 !important;
            outline: none !important;
        }

        svg {
            stroke: ${getColor(colorStrings.primaryMain)};
        }
    `,
};

headerStyles.invoiceCountGridItem = {
    ...headerStyles.invoiceCountGridItem,
    css: css`
        ${headerStyles.invoiceCountGridItem?.css}
        align-self: center;
    `,
};